// extracted by mini-css-extract-plugin
export default {"cta":"AF-z","disabled":"BF-z"};